import React, { useEffect} from 'react';
import useScreenShareParticipant from '../../hooks/useScreenShareParticipant';
import useVideoContext from '../../hooks/useVideoContext';
import { Logger } from '../../utils';
import { UncontrolledTooltip } from 'reactstrap';

export const SCREEN_SHARE_TEXT = 'Share Screen';
export const STOP_SCREEN_SHARE_TEXT = 'Stop Sharing Screen';
export const SHARE_IN_PROGRESS_TEXT = 'Cannot share screen when another user is sharing';
export const SHARE_NOT_SUPPORTED_TEXT = 'Screen sharing is not available on this browser.';

export default function ToggleScreenShareButton(props) { 
    const screenShareParticipant = useScreenShareParticipant();
    const { room, isSharingScreen, toggleScreenShare } = useVideoContext();
    const disableScreenShareButton = screenShareParticipant && screenShareParticipant !== room.localParticipant;
    const isScreenShareSupported = navigator.mediaDevices && navigator.mediaDevices.getDisplayMedia;
    const isDisabled = props.disabled || disableScreenShareButton || !isScreenShareSupported;

    let tooltipMessage = SCREEN_SHARE_TEXT;

    if (isSharingScreen) {
        tooltipMessage = STOP_SCREEN_SHARE_TEXT;
    }

    if (disableScreenShareButton) {
        tooltipMessage = SHARE_IN_PROGRESS_TEXT;
    }

    if (!isScreenShareSupported) {
        tooltipMessage = SHARE_NOT_SUPPORTED_TEXT;
    }

    const screenSharingBtnClicked = () => {
        Logger(`UI.Twilio.Room.ShareScreen.${isSharingScreen ? "Stop" : "Start"}.Clicked`, new Date());
        toggleScreenShare();
    };

    useEffect(() => {       
        let participant = "";
        let activityLog = "";
        if (!isScreenShareSupported) {
            activityLog = "UI.Twilio.Room.ShareScreen.Disabled.ScreenShareNotSupported";
            participant = room.localParticipant;
        }
        else if (disableScreenShareButton) {
            activityLog = "UI.Twilio.Room.ShareScreen.Disabled.AnotherPersonSharing";
            participant = screenShareParticipant;
        }

        if (activityLog && participant)
            Logger(activityLog, new Date(), { "participant": participant });

    }, [isScreenShareSupported, disableScreenShareButton]);

    return (       
       <React.Fragment>
            <button type="button" className={`btn btn-primary share-btn`} disabled={isDisabled} onClick={isDisabled ? null : screenSharingBtnClicked} id="btn-share"><span className={`${isSharingScreen ? " icon-stop-share-screen" : " icon-share-screen"}`} /></button>
            {!isScreenShareSupported && <UncontrolledTooltip target="btn-share" placement="top">{SHARE_NOT_SUPPORTED_TEXT}</UncontrolledTooltip>}
        </React.Fragment>
    );
}
